import React from 'react';
import ClientListGrid, { useClientListGrid } from './ClientListGrid';
import { GridText } from './gridCell';

/**
 * Client-side sort / filter / column menu table (wraps ClientListGrid + useClientListGrid).
 */
const SortFilterTable = ({
  columns,
  rows,
  getCellValue,
  renderCell,
  loading = false,
  loadingText = 'Loading...',
  emptyText = 'No records found',
  minWidth = '1100px',
  maxHeight = 560,
  showPagination = true,
  leadingHeader = null,
  renderLeadingCell = null,
  extraColSpan = 0,
  tableClassName = 'data-grid-table w-full',
  serialHeader = '#',
  footerExtra = null,
  onRowClick = null,
  onRowContextMenu = null,
  getRowClassName = null,
  getCellClassName = null,
  compact = false,
  grid: externalGrid = null,
  initialPageSize = 20,
}) => {
  const internalGrid = useClientListGrid({
    columns,
    rows: rows || [],
    getCellValue,
    initialPageSize,
  });
  const grid = externalGrid || internalGrid;

  const defaultRenderCell = (row, column) => {
    if (column.field === 'actions') return null;
    const val = getCellValue ? getCellValue(row, column.field) : row[column.field];
    return <GridText value={val} />;
  };

  return (
    <ClientListGrid
      columns={columns}
      grid={grid}
      renderCell={renderCell || defaultRenderCell}
      loading={loading}
      loadingText={loadingText}
      emptyText={emptyText}
      minWidth={minWidth}
      maxHeight={maxHeight}
      showPagination={showPagination}
      leadingHeader={leadingHeader}
      renderLeadingCell={renderLeadingCell}
      extraColSpan={extraColSpan}
      tableClassName={tableClassName}
      serialHeader={serialHeader}
      footerExtra={footerExtra}
      onRowClick={onRowClick}
      onRowContextMenu={onRowContextMenu}
      getRowClassName={getRowClassName}
      getCellClassName={getCellClassName}
      compact={compact}
      rowKey={(row) => row.Id ?? row.id}
    />
  );
};

export { useClientListGrid };
export default SortFilterTable;
